import Box from '@mui/material/Box';
import { selectTotalProgress } from '../store/features/progress/downloadSelectors';
import { useAppSelector } from '../store/hooks';
import CheckIcon from '@mui/icons-material/Check';
import Typography from '@mui/material/Typography';
import Fade from '@mui/material/Fade';
import CircularProgress from '@mui/material/CircularProgress';
import { green } from '@mui/material/colors';

export const Downloads = () => {
    const { progress, all, done } = useAppSelector(selectTotalProgress);
    const ready = all !== 0 && all === done;

    return (
        <Box textAlign='center' height='100%' width='100%' display='flex'>
            <Box margin='auto'>
                <Typography variant='h4'>Trwa wczytywanie</Typography>
                <br />
                <Box
                    position='relative'
                    display='flex'
                    alignItems='center'
                    justifyContent='center'
                    height={120}
                    width={120}
                    margin='auto'
                >
                    <Box margin='auto'>
                        {ready ? (
                            <Fade in timeout={1000}>
                                <CheckIcon sx={{ width: 90, height: 90, color: green[500], margin: 'auto' }} />
                            </Fade>
                        ) : (
                            <Typography variant='h6' color='text.secondary'>{`${done}/${all}`}</Typography>
                        )}
                    </Box>
                    <CircularProgress
                        variant='determinate'
                        value={progress}
                        size={120}
                        sx={{
                            position: 'absolute',
                            zIndex: 1,
                            transition: '1s color',
                            color: ready ? green[500] : undefined
                        }}
                    />
                </Box>
            </Box>
        </Box>
    );
};
